import color from 'tinycolor2'
import { isBrowser } from 'env'
import { percentageRegex } from 'tools/string'
import { getUserAgent, isIPhoneX } from 'tools/userAgent'

export const getColorString = (c) => color(c).toString()

export const forScreen = (bg, screen, def) => (bg instanceof Object ? bg[screen] : bg) || def

export const lighten = (c, amt) => color(c).lighten(amt).toString()

export const darken = (c, amt) => color(c).darken(amt).toString()

export const setAlpha = (c, a = 0.5) => color(c).setAlpha(a).toRgbString()

export const getMobileHeight = () => isBrowser() ? `${window.innerHeight}px` : '100vh'

export const pixelise = (value) => value === null || Array.isArray(value) || isNaN(+value) ? value : `${value}px`

export const numberise = (value) => +((value + '').replace(/px/, ''))

export const getColor = (skins, key, type, def = '') => skins[key] ? skins[key][type] : def

export const main = (skins, key, def) => getColor(skins, key, 'main', def)

export const alt = (skins, key, def) => getColor(skins, key, 'alt', def)

export const MEDIUM_DELAY = 300

export const SCROLL_THRESHOLD = 100

export const isPercentage = string => percentageRegex.test(string)

export const hexToRgb = (hex) => {
  const hexRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i
  const validHex = hexRegex.exec(hex)
  return validHex ? {
    r: parseInt(validHex[1], 16),
    g: parseInt(validHex[2], 16),
    b: parseInt(validHex[3], 16)
  } : {
    r: 255,
    g: 255,
    b: 255
  }
}

export const isLight = (c) => {
  return color(c).isLight()
}

export const isDark = (c) => {
  return color(c).isDark()
}

const BROWSER_INFO_KEY = '__browser'
export const injectBrowserInfo = () => {
  if (isBrowser() && !window.document.documentElement.classList.contains(BROWSER_INFO_KEY)) {
    const ua = getUserAgent()
    window.document.documentElement.classList.add(BROWSER_INFO_KEY)
    ua.browser && ua.browser.name && window.document.documentElement.classList.add(ua.browser.name.replace(/ /g, ''))
    if (isIPhoneX(ua)) {
      window.document.documentElement.classList.add('iPhoneX')
    }
  }
}

export const matchMedia = (prop, value) => window.matchMedia(`(${prop}: ${value}px)`).matches

export const lightenOrDarken = (c, amt) => isLight(c) ? darken(c, amt) : lighten(c, amt)
